import styled from 'styled-components'

const ScrolledDiv = styled.div`
overflow-y: scroll;
`;

export default ScrolledDiv;